import { render, staticRenderFns } from "./observation_item_list.vue?vue&type=template&id=0f2d47d6"
import script from "./observation_item_list.vue?vue&type=script&lang=js"
export * from "./observation_item_list.vue?vue&type=script&lang=js"
import style0 from "./observation_item_list.vue?vue&type=style&index=0&id=0f2d47d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports